/* menu-drawer.js — <menu-drawer> custom element. Framework-free, deferred. */
(function () {
  'use strict';

  function a11y(key, fallback) {
    return window.puString ? window.puString(key, fallback) : fallback;
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  // First control that is actually shown. Hidden drill panels stay out of the sequence.
  function focusFirst(root) {
    if (!root) return false;
    var nodes = root.querySelectorAll(FOCUSABLE);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('[hidden]') || !el.getClientRects().length) continue;
      el.focus({ preventScroll: true });
      if (document.activeElement === el) return true;
    }
    return false;
  }

  function hubLinkFrom(target) {
    var link = target && target.closest ? target.closest('a[href*="#k-hub"]') : null;
    if (!link) return null;
    // Same ignore rule Klaviyo uses. "false" still counts as a hub link.
    var ignore = link.getAttribute('data-k-hub-ignore');
    if (ignore != null && ignore !== 'false') return null;
    return link;
  }

  var SKIP_BACKGROUND = { SCRIPT: 1, STYLE: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  // Shown controls only. hidden, inert, display:none, and visibility:hidden
  // (closed submenu panels) are not tab stops. visibility:hidden still has
  // client rects, so the style check is required.
  function isShown(el) {
    if (!el || el.disabled || el.tabIndex < 0) return false;
    if (el.closest('[hidden]') || el.closest('[inert]')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  // The trap focuses with preventScroll, so a Featured card can take focus
  // while it sits off the horizontal row. nearest scrolls only the overflow
  // that is actually clipping the control. The page scroll is put back: the
  // drawer is fixed, and the body is already locked. html uses smooth
  // scroll-behavior, so the row, the panel, and the document are pinned to
  // auto for this call. That keeps prefers-reduced-motion instant, and it
  // keeps a normal-motion page from animating a vertical jump.
  function revealFocused(el) {
    if (!el || !el.scrollIntoView || !el.closest) return;
    var row = el.closest('.menu-drawer__featured');
    if (!row) return;
    var winX = window.scrollX;
    var winY = window.scrollY;
    var panel = el.closest('.menu-drawer__panel');
    var nodes = [row, panel, document.documentElement, document.body];
    var saved = [];
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node || !node.style) continue;
      saved.push(node, node.style.scrollBehavior);
      node.style.scrollBehavior = 'auto';
    }
    // 'auto' follows the pinned scroll-behavior. 'instant' throws on older Safari.
    el.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
    if (window.scrollX !== winX || window.scrollY !== winY) window.scrollTo(winX, winY);
    for (var j = 0; j < saved.length; j += 2) saved[j].style.scrollBehavior = saved[j + 1];
  }

  function rememberNode(nodes, el) {
    if (!el || el.nodeType !== 1 || SKIP_BACKGROUND[el.tagName]) return;
    for (var i = 0; i < nodes.length; i++) if (nodes[i] === el) return;
    nodes.push(el);
  }

  // Header controls that stay live while the menu is open. The burger is the
  // visible close. Search, Account, and Cart open their own sheet or page.
  // Join navigates. The logo navigates home, or closes the drawer and scrolls
  // to the top when this page is already home. A real tap never reaches an
  // inert control, and moving focus on touchstart cancels the click on iOS,
  // so the logo stays out of the inert set and in the focus trap. The heart
  // and the utility-bar links stay inert with the rest of the page.
  var HEADER_LIVE_SELECTORS = [
    '.site-header__logo',
    '[data-search-drawer-toggle]',
    '.site-header__action--account',
    '[data-cart-drawer-toggle]',
    '.site-header__join'
  ];
  // Search, Cart, Account, and Join use the menu close path, then their own
  // action. The click is not cancelled, so Join still follows its link.
  var HEADER_SHEET_SELECTOR = '[data-search-drawer-toggle], .site-header__action--account, [data-cart-drawer-toggle], .site-header__join';

  function headerLiveControls(toggle) {
    var header = document.querySelector('.site-header');
    var list = [];
    function add(el) {
      if (!el) return;
      for (var i = 0; i < list.length; i++) if (list[i] === el) return;
      list.push(el);
    }
    add(toggle);
    if (header) {
      for (var s = 0; s < HEADER_LIVE_SELECTORS.length; s++) add(header.querySelector(HEADER_LIVE_SELECTORS[s]));
    }
    list.sort(function (a, b) {
      if (a === b) return 0;
      var pos = a.compareDocumentPosition(b);
      if (pos & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
      if (pos & Node.DOCUMENT_POSITION_PRECEDING) return 1;
      return 0;
    });
    return list;
  }

  function holdsLive(el, keeps) {
    if (!el || !keeps) return false;
    for (var i = 0; i < keeps.length; i++) {
      var keep = keeps[i];
      if (!keep) continue;
      if (el === keep || el.contains(keep)) return true;
    }
    return false;
  }

  function pathOf(href) {
    try {
      var url = new URL(href, window.location.href);
      return { origin: url.origin, path: (url.pathname.replace(/\/+$/, '') || '/') };
    } catch (err) {
      return null;
    }
  }

  function targetIsLive(target, keeps) {
    if (!target || !keeps) return false;
    for (var i = 0; i < keeps.length; i++) {
      var keep = keeps[i];
      if (!keep) continue;
      if (target === keep || keep.contains(target)) return true;
    }
    return false;
  }

  // Everything under `container` except the live header controls and the dialog.
  // Ancestors of those controls are not marked, because inert on a parent
  // would swallow a real tap even when the control itself has no attribute.
  function collectExceptAll(container, keeps, host, nodes) {
    var children = container.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child === host || child.contains(host)) continue;
      if (!holdsLive(child, keeps)) {
        rememberNode(nodes, child);
        continue;
      }
      var isKeep = false;
      for (var k = 0; k < keeps.length; k++) if (child === keeps[k]) isKeep = true;
      if (!isKeep) collectExceptAll(child, keeps, host, nodes);
    }
  }

  // Mark on each node hideBackground actually locks. The value says which
  // attributes this drawer set, so a later sweep can undo those and nothing else.
  var MENU_LOCK_ATTR = 'data-menu-lock';

  // True when this document still has the menu's own lock or a visible panel.
  // The drawer's is-open class, nodes this drawer tagged, the root panel,
  // the drawer hidden state, and html.menu-drawer-open count. Another
  // overlay's inert or aria-hidden (Quick View, sticky add-to-cart, the
  // bulk bar, cart, search) does not. Scroll lock alone does not either:
  // the cart drawer uses the same overflow.
  function menuLockDirty(drawer) {
    if (!drawer) return false;
    if (drawer.classList.contains('is-open')) return true;
    if (document.documentElement.classList.contains('menu-drawer-open')) return true;
    var panel = drawer.querySelector('#MenuDrawer');
    if (panel && !panel.hidden) return true;
    var root = drawer.querySelector('.menu-drawer__panel[data-panel="root"]');
    if (root && root.hasAttribute('inert')) return true;
    if (document.querySelector('[' + MENU_LOCK_ATTR + ']')) return true;
    return false;
  }

  var pageShowBound = false;
  function bindPageShow() {
    if (pageShowBound) return;
    pageShowBound = true;
    // pagehide and pageshow do not bubble. A same-tab navigation can freeze
    // this document in the back-forward cache while the menu is still open.
    // pagehide clears the menu's own lock before that snapshot. It does not
    // run when only another overlay is locking the page. pageshow persisted
    // clears the menu lock again, including a snapshot taken before this
    // listener ran, and always drops html.menu-drawer-open.
    window.addEventListener('pagehide', function () {
      var drawer = document.querySelector('menu-drawer');
      if (!drawer || typeof drawer.releasePageLock !== 'function') return;
      if (!menuLockDirty(drawer)) return;
      drawer.releasePageLock();
    });
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var drawer = document.querySelector('menu-drawer');
      if (drawer && typeof drawer.releasePageLock === 'function') {
        if (menuLockDirty(drawer)) drawer.releasePageLock();
      }
      document.documentElement.classList.remove('menu-drawer-open');
    });
  }

  class MenuDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('#MenuDrawer');
      this.toggle = document.querySelector('[data-menu-drawer-toggle]');
      this.ensureCloseButton();

      if (this.toggle) {
        // A tap sets this before click. Enter and Space clear it so a keyboard
        // open still focuses the in-drawer X. detail > 0 covers a tap whose
        // click never got a pointerdown.
        this._pointerOpen = false;
        this.toggle.addEventListener('pointerdown', () => { this._pointerOpen = true; });
        this.toggle.addEventListener('pointercancel', () => { this._pointerOpen = false; });
        this.toggle.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') this._pointerOpen = false;
        });
        this.toggle.addEventListener('click', (event) => {
          var pointer = this._pointerOpen || event.detail > 0;
          this._pointerOpen = false;
          if (this.classList.contains('is-open')) this.close();
          else this.open({ pointer: pointer });
        });
      }
      this.querySelectorAll('[data-menu-drawer-close]').forEach((el) => {
        if (el._menuCloseBound) return;
        el._menuCloseBound = true;
        el.addEventListener('click', () => this.close());
      });
      // Capture, before Search and Cart handle the click and before Account
      // or Join navigates. A real tap never reaches an inert control.
      // element.click() still fires, which is why a scripted smoke can miss
      // this. Join is in HEADER_SHEET_SELECTOR, so the menu closes and the
      // link still navigates.
      this._onHeaderSheet = (e) => this.onHeaderSheet(e);
      document.addEventListener('click', this._onHeaderSheet, true);
      // Capture, same as the sheet controls. The logo is outside the drawer.
      // Do not stop the event. Away from home, do not preventDefault, or iOS
      // and Chrome will not follow the link. On home, preventDefault and
      // scroll, because a same-URL tap otherwise does nothing visible.
      this._logoFocusFromDrawer = false;
      this._onHeaderLogoPress = (e) => this.onHeaderLogoPress(e);
      this._onHeaderLogoPointerUp = (e) => this.onHeaderLogoPointerUp(e);
      document.addEventListener('pointerdown', this._onHeaderLogoPress, true);
      document.addEventListener('pointerup', this._onHeaderLogoPointerUp, true);
      document.addEventListener('pointercancel', this._onHeaderLogoPointerUp, true);
      this._onHeaderLogo = (e) => this.onHeaderLogo(e);
      document.addEventListener('click', this._onHeaderLogo, true);
      // Capture runs before Klaviyo's bubble listener on the anchor. That
      // listener opens #k-hub and sends Escape. #k-hub is z-index auto, under
      // this drawer, so the drawer has to be visually gone before that open.
      // Do not preventDefault and do not stop the event. Klaviyo bound its
      // listener to these anchors directly. A replacement click would miss it.
      this.addEventListener('click', (e) => {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (e.defaultPrevented) return;
        var link = hubLinkFrom(e.target);
        if (!link || !this.contains(link) || !this.classList.contains('is-open')) return;
        this.close({ immediate: true });
      }, true);
      // Same-tab links inside the drawer (Shop tiles, account, utility).
      // A new tab does not leave this page, so the menu stays as it is.
      // Do not preventDefault. immediate keeps hidden off this click, or the
      // navigation would be cancelled. restoreFocus false so the burger does
      // not take focus away from the navigation.
      this.addEventListener('click', (e) => this.onDrawerNavigate(e), true);
      this._onFeaturedFocus = (e) => { if (e.target) revealFocused(e.target); };
      this._featuredRows = this.querySelectorAll('.menu-drawer__featured');
      for (var fr = 0; fr < this._featuredRows.length; fr++) {
        this._featuredRows[fr].addEventListener('focusin', this._onFeaturedFocus);
      }
      bindPageShow();
      // keydown clears a logo press that never became a click, before Enter's
      // click can read it. Esc still closes from the root and from a submenu.
      this._onMenuKey = (e) => {
        this._logoFocusFromDrawer = false;
        if (e.key === 'Escape' && this.classList.contains('is-open')) this.close();
      };
      document.addEventListener('keydown', this._onMenuKey);

      // Two-level drill: category tile -> sub-panel; back -> root.
      this.querySelectorAll('[data-drill]').forEach((btn) =>
        btn.addEventListener('click', () => this.drill(btn.getAttribute('data-drill'), btn))
      );
      this.querySelectorAll('[data-drill-back]').forEach((btn) =>
        btn.addEventListener('click', () => this.back())
      );
    }

    drill(index, tile) {
      var panel = this.querySelector('.menu-drawer__panel--sub[data-panel="' + index + '"]');
      if (!panel) return;
      this._drillTile = (tile && tile.isConnected) ? tile : this.querySelector('[data-drill="' + index + '"]');
      this.querySelectorAll('.menu-drawer__panel--sub.is-active').forEach((p) => p.classList.remove('is-active'));
      panel.hidden = false;
      // Classes land next frame. Back cannot take focus until the panel is shown.
      this._drillToken = (this._drillToken || 0) + 1;
      var token = this._drillToken;
      requestAnimationFrame(() => {
        if (token !== this._drillToken || !this.classList.contains('is-open')) return;
        panel.classList.add('is-active');
        this.classList.add('is-drilled');
        this.setRootInert(true);
        var back = panel.querySelector('[data-drill-back]');
        if (back) back.focus({ preventScroll: true });
      });
    }

    back() {
      this._drillToken = (this._drillToken || 0) + 1;
      var active = this.querySelector('.menu-drawer__panel--sub.is-active');
      var tile = this._drillTile;
      this.setRootInert(false);
      this.classList.remove('is-drilled');
      if (tile && tile.isConnected) tile.focus({ preventScroll: true });
      if (active) {
        active.classList.remove('is-active');
        var onEnd = () => { active.hidden = true; active.removeEventListener('transitionend', onEnd); };
        active.addEventListener('transitionend', onEnd);
      }
    }

    setRootInert(on) {
      var root = this.querySelector('.menu-drawer__panel[data-panel="root"]');
      if (!root) return;
      if (on) root.setAttribute('inert', '');
      else root.removeAttribute('inert');
    }

    resetPanels() {
      this._drillToken = (this._drillToken || 0) + 1;
      this.classList.remove('is-drilled');
      this.setRootInert(false);
      this._drillTile = null;
      this.querySelectorAll('.menu-drawer__panel--sub').forEach((p) => { p.classList.remove('is-active'); p.hidden = true; });
    }

    ensureCloseButton() {
      if (!this.drawer || this.drawer.querySelector('.menu-drawer__close')) return;
      // Locale string comes from the host. No English literal in this fallback.
      var label = this.getAttribute('data-close-label');
      if (!label) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'menu-drawer__close';
      btn.setAttribute('data-menu-drawer-close', '');
      btn.setAttribute('aria-label', label);
      btn.addEventListener('click', () => this.close());
      btn._menuCloseBound = true;
      btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg>';
      this.drawer.insertBefore(btn, this.drawer.firstChild);
    }

    setLauncherHidden(hidden) {
      // Class only. The stylesheet hides .kl-hub-launcher-container. The node stays.
      document.documentElement.classList.toggle('menu-drawer-open', !!hidden);
    }

    // Same-tab drawer link. Hub links also match and close in the handler
    // above. This one covers every other in-drawer anchor that will replace
    // this document. Modifiers and target=_blank stay on this page.
    onDrawerNavigate(e) {
      if (!this.classList.contains('is-open')) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.defaultPrevented) return;
      var target = e.target;
      if (!target || !target.closest) return;
      var link = target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      if (link.hasAttribute('download')) return;
      var frame = (link.getAttribute('target') || '').trim().toLowerCase();
      if (frame === '_blank') return;
      var href = link.getAttribute('href') || '';
      if (!href || href.indexOf('javascript:') === 0) return;
      this.close({ immediate: true, restoreFocus: false });
    }

    // Search, Cart, Account, and Join. Same close() as the X, with
    // restoreFocus false, so finish() still clears html.menu-drawer-open and
    // the Klaviyo bubble can return. Do not preventDefault and do not stop
    // the event. The control's own listener then opens the sheet, or the
    // browser follows Account or Join.
    onHeaderSheet(e) {
      if (!this.classList.contains('is-open')) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var target = e.target;
      if (!target || !target.closest) return;
      var hit = target.closest(HEADER_SHEET_SELECTOR);
      if (!hit || hit.closest('menu-drawer')) return;
      var header = document.querySelector('.site-header');
      if (!header || !header.contains(hit)) return;
      this.close({ restoreFocus: false });
    }

    // A pointer press focuses the logo on pointerdown, before click. Record
    // whether focus was still in the open menu at that press. Enter never
    // fires this, so a keyboard activation keeps focus on the logo.
    onHeaderLogoPress(e) {
      this._logoFocusFromDrawer = false;
      if (!this.classList.contains('is-open')) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var target = e.target;
      if (!target || !target.closest) return;
      var link = target.closest('a.site-header__logo');
      if (!link || link.closest('menu-drawer')) return;
      var header = document.querySelector('.site-header');
      if (!header || !header.contains(link)) return;
      var active = document.activeElement;
      this._logoFocusFromDrawer = !!(this.drawer && active && (active === this.drawer || this.drawer.contains(active)));
    }

    // A press that ends off the logo does not click it. Drop the record so a
    // later Enter does not inherit it.
    onHeaderLogoPointerUp(e) {
      if (!this._logoFocusFromDrawer) return;
      if (e.type === 'pointercancel') {
        this._logoFocusFromDrawer = false;
        return;
      }
      var target = e.target;
      if (!target || !target.closest || !target.closest('a.site-header__logo')) {
        this._logoFocusFromDrawer = false;
      }
    }

    // Logo tap while the menu is open. The drawer starts below the header, so
    // this is not an overlay hit. inert used to drop the tap on the header
    // row behind the wordmark. Away from home the browser follows the link
    // and the menu closes without taking focus. On home the menu closes and
    // the page scrolls to the top. Enter on an already-focused logo keeps
    // focus there. A click that never moved focus onto the logo (VoiceOver,
    // Switch Control, or a click with no press) must move focus to the skip
    // target, or closing the drawer drops it on body.
    onHeaderLogo(e) {
      // detail 0 keeps a stale press from sending a later Enter to the skip
      // target. It does not by itself mean the logo already has focus.
      var focusWasInDrawer = !!this._logoFocusFromDrawer && e.detail > 0;
      this._logoFocusFromDrawer = false;
      if (!this.classList.contains('is-open')) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var target = e.target;
      if (!target || !target.closest) return;
      var link = target.closest('a.site-header__logo');
      if (!link || link.closest('menu-drawer')) return;
      var header = document.querySelector('.site-header');
      if (!header || !header.contains(link)) return;
      var dest = pathOf(link.getAttribute('href') || link.href);
      var here = pathOf(window.location.href);
      var same = dest && here && dest.origin === here.origin && dest.path === here.path;
      if (same) {
        e.preventDefault();
        var onLogo = document.activeElement === link;
        this.close({ restoreFocus: false });
        if (window.location.hash) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        window.scrollTo(0, 0);
        if (focusWasInDrawer || !onLogo) {
          var pageTop = document.getElementById('MainContent');
          if (pageTop && pageTop.focus) pageTop.focus({ preventScroll: true });
        }
        return;
      }
      this.close({ immediate: true, restoreFocus: false });
    }

    // Page behind the dialog. inert (and aria-hidden, same pairing as quick view)
    // is the lock: a Tab wrap alone still leaves the background in the
    // accessibility tree, and background nodes can take focus without Tab.
    // The burger, the logo, and the live header actions stay out of this set.
    // They sit in the header, outside #MenuDrawer, and a real tap has to
    // reach them. inert on an ancestor would block that tap. Their parents
    // are walked so only the rest of the header (heart, utility links) is locked.
    backgroundNodes() {
      var nodes = [];
      var host = this;
      var keeps = headerLiveControls(this.toggle);
      var node = host;
      while (node && node !== document.body && node.parentElement) {
        var parent = node.parentElement;
        var children = parent.children;
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          if (child === node || child === host) continue;
          if (holdsLive(child, keeps)) {
            collectExceptAll(child, keeps, host, nodes);
            continue;
          }
          if (child.contains(host)) continue;
          rememberNode(nodes, child);
        }
        node = parent;
      }
      return nodes;
    }

    hideBackground() {
      if (this._background) this.showBackground();
      var nodes = this.backgroundNodes();
      var hidden = [];
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el || !el.isConnected) continue;
        if (el.contains(this) || this.contains(el)) continue;
        if (holdsLive(el, headerLiveControls(this.toggle))) continue;
        if (document.activeElement && el.contains(document.activeElement)) continue;
        var hadAria = el.hasAttribute('aria-hidden');
        var ariaVal = hadAria ? el.getAttribute('aria-hidden') : null;
        var hadInert = el.hasAttribute('inert');
        // Already locked by someone else. Leave it, and do not tag it.
        if (hadAria && ariaVal === 'true' && hadInert) continue;
        var ariaSet = !(hadAria && ariaVal === 'true');
        var inertSet = !hadInert;
        var flag = '';
        if (ariaSet) flag = 'aria';
        if (inertSet) flag = flag ? flag + ' inert' : 'inert';
        hidden.push({ el: el, aria: hadAria, ariaVal: ariaVal, inert: hadInert });
        if (ariaSet) el.setAttribute('aria-hidden', 'true');
        if (inertSet) el.setAttribute('inert', '');
        el.setAttribute(MENU_LOCK_ATTR, flag);
      }
      this._background = hidden;
    }

    // Undo hideBackground. Safe when open() never engaged the trap
    // (_background is missing). A second call is a no-op aside from the
    // leftover sweep. The sweep only removes data-menu-lock, and only the
    // attributes the flag says this drawer set. Untagged inert and
    // aria-hidden stay, including Quick View, sticky add-to-cart, the bulk
    // bar, and the cart and search sheets.
    showBackground() {
      var list = this._background;
      this._background = null;
      if (list && typeof list.length === 'number') {
        for (var i = 0; i < list.length; i++) {
          var rec = list[i];
          if (!rec) continue;
          var el = rec.el;
          if (!el || !el.removeAttribute) continue;
          if (rec.aria) el.setAttribute('aria-hidden', rec.ariaVal == null ? '' : rec.ariaVal);
          else el.removeAttribute('aria-hidden');
          if (!rec.inert) el.removeAttribute('inert');
          el.removeAttribute(MENU_LOCK_ATTR);
        }
      }
      this.clearLeftoverLock();
    }

    clearLeftoverLock() {
      var tagged = document.querySelectorAll('[' + MENU_LOCK_ATTR + ']');
      for (var i = 0; i < tagged.length; i++) {
        var el = tagged[i];
        var flag = el.getAttribute(MENU_LOCK_ATTR) || '';
        // The flag is the record of what this drawer set. A missing in-memory
        // list (a frozen page) still undoes only those attributes.
        if (flag.indexOf('aria') !== -1) el.removeAttribute('aria-hidden');
        if (flag.indexOf('inert') !== -1) el.removeAttribute('inert');
        el.removeAttribute(MENU_LOCK_ATTR);
      }
    }

    // Sync unlock for bfcache and any close that must not wait on a timer.
    // Does not move focus. Safe when the trap was never set.
    releasePageLock() {
      this._logoFocusFromDrawer = false;
      if (this._openFrame) {
        cancelAnimationFrame(this._openFrame);
        this._openFrame = 0;
      }
      this._drillToken = (this._drillToken || 0) + 1;
      this._closeToken = (this._closeToken || 0) + 1;
      this.classList.remove('is-open');
      this.classList.remove('is-hub-close');
      this.classList.remove('is-drilled');
      this.setRootInert(false);
      this.releaseTrap();
      this.setLauncherHidden(false);
      document.body.style.overflow = '';
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', a11y('menu', 'Menu'));
      }
      if (this.drawer) this.drawer.hidden = true;
      this.resetPanels();
    }

    // Tab order: (Join if shown), logo, Search, Account, Cart, burger, drawer.
    // Join is the utility-bar control and only shows from 1200px. It precedes
    // the logo in the document. The page behind is inert and is not in this
    // list, so Tab cannot reach it. The logo stays in so a tap can focus it
    // without the trap cancelling the click. The heart stays out: it is not
    // one of the live header actions.
    tabStops() {
      var stops = [];
      var activePanel = this.classList.contains('is-drilled')
        ? this.querySelector('.menu-drawer__panel--sub.is-active')
        : this.querySelector('.menu-drawer__panel[data-panel="root"]');
      var keeps = headerLiveControls(this.toggle);
      for (var k = 0; k < keeps.length; k++) {
        if (isShown(keeps[k])) stops.push(keeps[k]);
      }
      if (!this.drawer) return stops;
      var nodes = this.drawer.querySelectorAll(FOCUSABLE);
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var panel = el.closest('.menu-drawer__panel');
        if (panel && activePanel && panel !== activePanel) continue;
        if (!isShown(el)) continue;
        stops.push(el);
      }
      return stops;
    }

    stopIndex(stops, node) {
      if (!node) return -1;
      for (var i = 0; i < stops.length; i++) {
        if (stops[i] === node || stops[i].contains(node)) return i;
      }
      return -1;
    }

    onTab(e) {
      if (!this._trapOn || e.key !== 'Tab' || e.altKey || e.ctrlKey || e.metaKey) return;
      var stops = this.tabStops();
      // Always move. A plain Tab from the burger used to fall through to the
      // root tiles, including while a submenu was open.
      e.preventDefault();
      if (!stops.length) return;
      var index = this.stopIndex(stops, document.activeElement);
      var next;
      // Pointer opens focus the dialog, which is not a tab stop. Tab from
      // there still lands on the in-drawer X. Shift+Tab lands on the burger.
      if (this.drawer && document.activeElement === this.drawer) {
        var drawerStart = stops.length;
        for (var d = 0; d < stops.length; d++) {
          if (this.drawer.contains(stops[d])) { drawerStart = d; break; }
        }
        if (e.shiftKey) next = drawerStart <= 0 ? stops.length - 1 : drawerStart - 1;
        else next = drawerStart >= stops.length ? 0 : drawerStart;
      } else if (e.shiftKey) next = index <= 0 ? stops.length - 1 : index - 1;
      else next = (index < 0 || index >= stops.length - 1) ? 0 : index + 1;
      stops[next].focus({ preventScroll: true });
      revealFocused(stops[next]);
    }

    onFocusIn(e) {
      if (!this._trapOn) return;
      var target = e.target;
      if (!target) return;
      if (targetIsLive(target, headerLiveControls(this.toggle))) return;
      if (this.contains(target)) return;
      var stops = this.tabStops();
      if (!stops.length) return;
      var dest = stops[0];
      for (var i = 0; i < stops.length; i++) {
        if (this.drawer && this.drawer.contains(stops[i])) { dest = stops[i]; break; }
      }
      if (document.activeElement === dest) return;
      dest.focus({ preventScroll: true });
    }

    engageTrap() {
      this.releaseTrap();
      this._trapOn = true;
      // Listen before inert runs. Hiding a focused node moves focus synchronously.
      this._onTrapKey = (e) => this.onTab(e);
      this._onTrapFocus = (e) => this.onFocusIn(e);
      document.addEventListener('keydown', this._onTrapKey, true);
      document.addEventListener('focusin', this._onTrapFocus, true);
      this.hideBackground();
    }

    // Open did not stick (the frame returned early, or it threw). Drop the
    // background lock, the scroll lock, the burger's expanded state, and the
    // launcher hide. Those last three are set after the frame is scheduled,
    // so a throw inside the frame used to leave them on with the drawer shut.
    abortOpen() {
      this.releaseTrap();
      this.setLauncherHidden(false);
      document.body.style.overflow = '';
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', a11y('menu', 'Menu'));
      }
    }

    releaseTrap() {
      this._trapOn = false;
      if (this._onTrapKey) {
        document.removeEventListener('keydown', this._onTrapKey, true);
        this._onTrapKey = null;
      }
      if (this._onTrapFocus) {
        document.removeEventListener('focusin', this._onTrapFocus, true);
        this._onTrapFocus = null;
      }
      // Lift inert before any focus move. Chrome blocks aria-hidden on an
      // ancestor that still contains the focused node.
      this.showBackground();
    }

    // Dialog container, not the X. tabindex -1 keeps it out of the tab order.
    // Returns false while visibility is still hidden so open() can retry.
    focusPanel() {
      var drawer = this.drawer;
      if (!drawer) return false;
      if (drawer.getAttribute('tabindex') !== '-1') drawer.setAttribute('tabindex', '-1');
      drawer.focus({ preventScroll: true });
      return document.activeElement === drawer;
    }

    open(opts) {
      var pointer = !!(opts && opts.pointer);
      // Cancel a close that has not finished hiding the panel.
      this._closeToken = (this._closeToken || 0) + 1;
      this.classList.remove('is-hub-close');
      // The menu opens below the header, so offset it by the header's current height.
      var header = document.querySelector('.site-header');
      if (header) this.drawer.style.setProperty('--header-h', header.offsetHeight + 'px');
      this.drawer.hidden = false;
      // Hide the launcher as the panel starts to open, not one frame later.
      this.setLauncherHidden(true);
      this.engageTrap();
      if (this._openFrame) cancelAnimationFrame(this._openFrame);
      // next frame so the transition runs, then move focus inside. Chrome blocks
      // aria-hidden on the rest of the page while the burger (outside the modal) is focused.
      this._openFrame = requestAnimationFrame(() => {
        this._openFrame = 0;
        var opened = false;
        try {
          if (!this.drawer || this.drawer.hidden) {
            if (!this.classList.contains('is-open')) this.setLauncherHidden(false);
            return;
          }
          this.classList.add('is-open');
          this.setLauncherHidden(true);
          opened = true;
          // The open transition keeps visibility hidden for a frame, so focus()
          // is a no-op until the next frame. Keyboard opens focus the in-drawer
          // X. Pointer and tap opens focus the dialog so iOS does not paint the
          // X :focus-visible ring. A failed pointer focus stays off the X.
          var placeFocus = () => (pointer ? this.focusPanel() : focusFirst(this.drawer));
          if (placeFocus()) return;
          this._openFrame = requestAnimationFrame(() => {
            this._openFrame = 0;
            var stillOpen = false;
            try {
              if (!this.classList.contains('is-open') || !this.drawer || this.drawer.hidden) return;
              stillOpen = true;
              placeFocus();
            } finally {
              if (!stillOpen) this.abortOpen();
            }
          });
        } finally {
          // A throw here used to leave inert, the scroll lock, and the
          // launcher hide on after the drawer had already failed to open.
          if (!opened) this.abortOpen();
        }
      });
      document.body.style.overflow = 'hidden';
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'true');
        this.toggle.setAttribute('aria-label', a11y('closeMenu', 'Close menu'));
      }
    }

    close(opts) {
      this._logoFocusFromDrawer = false;
      var immediate = !!(opts && opts.immediate);
      // Cart, Search, Account, and Join pass restoreFocus:false. Focusing the
      // burger now would stick, because the next sheet is still
      // visibility:hidden, and a focus move during Account or Join's click
      // can drop the navigation. Esc, the burger, and the in-drawer X do not
      // pass the flag, so those closes return focus to the burger.
      var restoreFocus = !opts || opts.restoreFocus !== false;
      if (this._openFrame) {
        cancelAnimationFrame(this._openFrame);
        this._openFrame = 0;
      }
      // Drop the background lock before moving focus. Every close returns to
      // the burger, including Esc after Tab has left the panel. A hub link
      // does not: moving focus in that click drops the hash that opens the hub.
      this._drillToken = (this._drillToken || 0) + 1;
      this.setRootInert(false);
      this.releaseTrap();
      if (!immediate && restoreFocus && this.toggle) this.toggle.focus({ preventScroll: true });
      if (immediate) this.classList.add('is-hub-close');
      this.classList.remove('is-open');
      // Hub links restore the launcher before #k-hub opens. Other closes keep
      // the class until the panel is actually hidden, so the bubble does not
      // flash over the footer while it fades. finish() always clears it.
      if (immediate) this.setLauncherHidden(false);
      document.body.style.overflow = '';
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.setAttribute('aria-label', a11y('menu', 'Menu'));
      }
      this._closeToken = (this._closeToken || 0) + 1;
      var token = this._closeToken;
      var finish = () => {
        if (token !== this._closeToken) return;
        if (this.classList.contains('is-open')) return;
        this._closeToken = (this._closeToken || 0) + 1;
        this.classList.remove('is-hub-close');
        this.setLauncherHidden(false);
        if (this.drawer) this.drawer.hidden = true;
        this.resetPanels();
      };
      if (immediate) {
        // hidden is display:none. Setting it in this click's capture phase
        // would cancel the rest of the event, so the hub would not open.
        // is-hub-close already took the panel off screen. Hide the node after
        // the click, including its default hash update, has finished.
        window.setTimeout(finish, 0);
        return;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }
      var onEnd = (e) => {
        if (e.target !== this.drawer) return;
        this.drawer.removeEventListener('transitionend', onEnd);
        finish();
      };
      this.drawer.addEventListener('transitionend', onEnd);
      window.setTimeout(finish, 450);
    }

    disconnectedCallback() {
      if (this._onMenuKey) {
        document.removeEventListener('keydown', this._onMenuKey);
        this._onMenuKey = null;
      }
      if (this._featuredRows && this._onFeaturedFocus) {
        for (var fr = 0; fr < this._featuredRows.length; fr++) {
          this._featuredRows[fr].removeEventListener('focusin', this._onFeaturedFocus);
        }
      }
      this._featuredRows = null;
      this._onFeaturedFocus = null;
      if (this._onHeaderSheet) {
        document.removeEventListener('click', this._onHeaderSheet, true);
        this._onHeaderSheet = null;
      }
      if (this._onHeaderLogoPress) {
        document.removeEventListener('pointerdown', this._onHeaderLogoPress, true);
        this._onHeaderLogoPress = null;
      }
      if (this._onHeaderLogoPointerUp) {
        document.removeEventListener('pointerup', this._onHeaderLogoPointerUp, true);
        document.removeEventListener('pointercancel', this._onHeaderLogoPointerUp, true);
        this._onHeaderLogoPointerUp = null;
      }
      if (this._onHeaderLogo) {
        document.removeEventListener('click', this._onHeaderLogo, true);
        this._onHeaderLogo = null;
      }
      this.setRootInert(false);
      this.releaseTrap();
      this.setLauncherHidden(false);
      document.body.style.overflow = '';
    }
  }

  if (!customElements.get('menu-drawer')) customElements.define('menu-drawer', MenuDrawer);
})();
